import UserDetail from '../components/Detail'
import useModalForm from '../../../@hooks/useModalForm'
import Service from '../../../@services/user'

export default function useModifierRoleDialog(cb) {
  const { open } = useModalForm(UserDetail)

  const openDialog = id => {
    return open(
      undefined,
      async () => {
        const res = (await Service.getDetail(id)) || {}
        return {
          id: res.id,
          username: res.username,
          name: res.name,
          password: res.initPassword,
          roles: res.roles || [],
          stores: res.stores || [],
          remark: res.remark,
          status: res.status,
          type: res.type,
          createdAt: res.createdAt,
        }
      },
      {
        title: '用户详情',
      }
    )
  }

  return openDialog
}
